import React, { useEffect, useState } from "react";
import { IoMdArrowDropright, IoMdArrowDropup } from "react-icons/io";
import { useSelector } from "react-redux";
import { viewAutoSwitch, getUser, getProvider } from "../../../config/LiveApi";
import MerchantDetailTable from "./MerchantDetailTable";
import "./TableView.css";
import { FaEdit, FaPlus } from "react-icons/fa";

const Table = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [merchantApikeys, setMerchantApikeys] = useState([]);
  const [users, setUsers] = useState([]);
  const [providerData, setProviderData] = useState([]);
  const [change, setChange] = useState(0);
  const [expandedMerchants, setExpandedMerchants] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isAdding, setIsAdding] = useState(false);
  const [openId, setOpenId] = useState(null);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const fetchProviderData = async () => {
      try {
        const response = await getProvider(token);
        const data = response?.data?.providers || [];
        setProviderData(data);
      } catch (error) {
        console.error("Error fetching provider data:", error.message);
      }
    };
    fetchProviderData();
  }, [token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [merchantData, userData] = await Promise.all([
          viewAutoSwitch(token),
          getUser(token),
        ]);
        setMerchantApikeys(merchantData);
        setUsers(userData.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [token,change]);

  const getUserNameById = (userId) => {
    const user = users.find((u) => u.id === userId);
    return user ? (user.alias || user.id) : "N/A";
  };

  const getProviderNameById = (id) => {
    const provider = providerData.find((p) => p.id === id);
    return provider ? provider.providerName : "N/A";
  };

  const handleExpandToggle = (userId,type) => {
    setExpandedMerchants((prev) => ({
      ...prev,
      [userId]: !prev[userId],
    }));
    if(type === 'edit'){
      setOpenId(null);
    }
    else if(type === 'view'){
      setOpenId(null);
      setIsAdding(false)
    }
    else setIsAdding(false);
  };

  const groupDataByMerchant = () => {
    const grouped = {};
    merchantApikeys.forEach((api) => {
      const key = api.userId;
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(api);
    });
    return Object.entries(grouped);
  };

  return (
    <div className="webhooks-report-table-container">
      <div className="user-sub-head">
        <h2 className="webhooks-report-table-title">
          View Auto Switch Merchant
        </h2>
      </div>

      <table className="webhooks-table">
        <thead>
          <tr>
            <th>Merchant Name</th>
            <th>Total Payment Mode</th>
            <th>Total Org</th>
            <th>Total Provider</th>
            <th>Average Success Rate (%)</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="5">Loading...</td>
            </tr>
          ) : merchantApikeys.length > 0 ? (
            groupDataByMerchant().map(([userId, data]) => {
              const merchantName = getUserNameById(userId);
              const totalPaymentModes = [
                ...new Set(data.map((d) => d.paymentMethod)),
              ].length;
              const totalOrgs = [...new Set(data.map((d) => d.orgName))].length;
              const totalProviders = [...new Set(data.map((d) => d.providerId))]
                .length;
              const avgSuccessRate =
                data.reduce(
                  (acc, d) => acc + (parseFloat(d.successRate) || 0),
                  0
                ) / data.length;
              const isExpanded = expandedMerchants[userId] || false;

              return (
                <React.Fragment key={userId}>
                  <tr
                    className="merchant-summary-row clickable-row"
                    onClick={() => handleExpandToggle(userId,'view')}
                  >
                    <td>
                      {isExpanded ? (
                        <IoMdArrowDropup size={21} />
                      ) : (
                        <IoMdArrowDropright size={21} />
                      )}{" "}
                      {merchantName}
                    </td>
                    <td>{totalPaymentModes}</td>
                    <td>{totalOrgs}</td>
                    <td>{totalProviders}</td>
                    <td>{avgSuccessRate.toFixed(2)}%</td>
                    <td>
                      <div className="add-update-buttons">
                        <FaEdit
                          onClick={(e) => {
                            e.stopPropagation();
                            handleExpandToggle(userId,'edit');
                            setOpenId(userId);
                            setIsAdding(false);
                          }}
                        />
                        <FaPlus  onClick={(e) => {
                            e.stopPropagation();
                            handleExpandToggle(userId,'add');
                            // setOpenId(userId);
                            setEditId(userId)
                            setIsAdding(true);
                          }}/>
                      </div>
                    </td>
                  </tr>
                  {isExpanded && (
                    <tr>
                      <td colSpan="7">
                        <MerchantDetailTable
                          openId={openId}
                          userId={userId}
                          setOpenId={setOpenId}
                          isEditing={openId === userId}
                          merchantName={merchantName}
                          isAdding={( isAdding)}
                          setIsAdding={setIsAdding}
                          data={data}
                          getProviderNameById={getProviderNameById}
                          setExpandedMerchants={setExpandedMerchants}
                          setChange={setChange}
                          change={change}
                        />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan="5">No Data Available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
